// utils/taskValidations.js
import { cookingTasks as staticTasks } from "../Static/task";

const POUR_TASK_MAP = {
  choose_grains: "pour_grain",
  choose_spices: "pour_spice",
  choose_soaks: "pour_soaks",
};

const REVERSE_POUR_MAP = {
  pour_grain: "choose_grains",
  pour_spice: "choose_spices",
  pour_soaks: "choose_soaks",
};

// export const cookingTasksValidation = (tasks) => {
//   let modifiedTasks = [...tasks];

//   // Helper functions
//   const hasTaskType = (type) => modifiedTasks.some((t) => t?.type === type);
//   const findTaskIndex = (type, start = 0) =>
//     modifiedTasks.findIndex((t, i) => i >= start && t?.type === type);
//   const generateId = () =>
//     `task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

//   // 1. Ensure chimney_on is first and chimney_off is last
//   if (!hasTaskType("chimney_on")) {
//     const chimneyOnTask = {
//       ...staticTasks.find((t) => t?.type === "chimney_on"),
//       id: generateId(),
//     };
//     modifiedTasks.unshift(chimneyOnTask);
//   }
//   if (!hasTaskType("chimney_off")) {
//     const chimneyOffTask = {
//       ...staticTasks.find((t) => t?.type === "chimney_off"),
//       id: generateId(),
//     };
//     modifiedTasks.push(chimneyOffTask);
//   }

//   // 2. Deduplicate choose_bowl and choose_cup by type and position (with item merging)
//   const typePositionMap = new Map();
//   const mergedTasks = [];

//   modifiedTasks.forEach((task) => {
//     if (["choose_bowl", "choose_cup"].includes(task?.type)) {
//       const key = `${task.type}_${task.position}`;

//       if (typePositionMap.has(key)) {
//         // Merge item names
//         const existing = typePositionMap.get(key);
//         existing.item_name = [existing.item_name, task.item_name]
//           .filter(Boolean)
//           .join(", ");
//       } else {
//         // Clone to avoid modifying original task
//         const clonedTask = {
//           ...task,
//           item_name: task.item_name || "",
//         };
//         typePositionMap.set(key, clonedTask);
//         mergedTasks.push(clonedTask);
//       }
//     } else {
//       mergedTasks.push(task);
//     }
//   });

//   modifiedTasks = mergedTasks;

//   // 3. Add pour tasks where needed (after open lid)
//   modifiedTasks.forEach((task, index) => {
//     const pourType = POUR_TASK_MAP[task?.type];
//     if (pourType) {
//       const previousOpenLidIndex = modifiedTasks
//         .slice(0, index)
//         .reverse()
//         .findIndex((t) => t?.type === "open_lid");
//       const nextCloseLidIndex = modifiedTasks
//         .slice(index)
//         .findIndex((t) => t?.type === "close_lid");

//       const hasPourTask = modifiedTasks
//         .slice(
//           index + 1,
//           nextCloseLidIndex > -1 ? index + nextCloseLidIndex : undefined
//         )
//         .some((t) => t?.type === pourType);

//       if (!hasPourTask) {
//         const pourTask = {
//           ...staticTasks.find((t) => t?.type === pourType),
//           id: generateId(),
//         };

//         if (previousOpenLidIndex === -1) {
//           const openLidTask = {
//             ...staticTasks.find((t) => t?.type === "open_lid"),
//             id: generateId(),
//           };
//           modifiedTasks.splice(index, 0, openLidTask);
//           modifiedTasks.splice(index + 1, 0, pourTask);
//         } else {
//           modifiedTasks.splice(index + 1, 0, pourTask);
//         }
//       }
//     }
//   });

//   // 4. Remove orphan pour tasks
//   modifiedTasks = modifiedTasks.filter((task, index) => {
//     if (REVERSE_POUR_MAP[task?.type]) {
//       const parentType = REVERSE_POUR_MAP[task?.type];
//       const hasParent = modifiedTasks
//         .slice(0, index)
//         .some((t) => t?.type === parentType);
//       const hasOpenLidBefore = modifiedTasks
//         .slice(0, index)
//         .some((t) => t?.type === "open_lid");
//       return hasParent && hasOpenLidBefore;
//     }
//     return true;
//   });

//   // 5. Validate heat on/off pairs
//   let heatOnIndex = -1;
//   modifiedTasks.forEach((task, index) => {
//     if (task?.function === "setHeat" && task?.level === "on") {
//       heatOnIndex = index;
//     }
//     if (
//       task?.function === "setHeat" &&
//       task?.level === "off" &&
//       heatOnIndex !== -1
//     ) {
//       heatOnIndex = -1;
//     }
//   });

//   if (heatOnIndex !== -1) {
//     const chimneyOffIndex = findTaskIndex("chimney_off");
//     const heatOffTask = {
//       ...staticTasks.find(
//         (t) => t?.function === "setHeat" && t?.level === "off"
//       ),
//       id: generateId(),
//     };
//     modifiedTasks.splice(chimneyOffIndex, 0, heatOffTask);
//   }

//   // Remove duplicates and invalid tasks
//   const seenIds = new Set();
//   return modifiedTasks.filter((task) => {
//     if (!task?.id || seenIds.has(task.id)) return false;
//     seenIds.add(task.id);
//     return true;
//   });
// };

export const cookingTasksValidation = (tasks) => {
  let modifiedTasks = [...tasks];

  // Helper functions
  const hasTaskType = (type) => modifiedTasks.some((t) => t?.type === type);
  const findTaskIndex = (type, start = 0) =>
    modifiedTasks.findIndex((t, i) => i >= start && t?.type === type);
  const generateId = () =>
    `task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  // 1. Ensure chimney_on is first and chimney_off is last
  if (!hasTaskType("chimney_on")) {
    const chimneyOnTask = {
      ...staticTasks.find((t) => t?.type === "chimney_on"),
      id: generateId(),
    };
    modifiedTasks.unshift(chimneyOnTask);
  }
  if (!hasTaskType("chimney_off")) {
    const chimneyOffTask = {
      ...staticTasks.find((t) => t?.type === "chimney_off"),
      id: generateId(),
    };
    modifiedTasks.push(chimneyOffTask);
  }

  // 2. Modified merge logic for choose_bowl and choose_cup
  const mergedTasks = [];
  const mergeMap = new Map();

  modifiedTasks.forEach((task) => {
    if (["choose_bowl", "choose_cup"].includes(task?.type)) {
      // Only merge if position is not empty and is a string that can be trimmed
      if (
        task &&
        task?.position &&
        typeof task.position === "string" &&
        task.position.trim() !== ""
      ) {
        const key = `${task.type}_${task.position}`;
        const existing = mergeMap.get(key);
        const currentQty = parseInt(task?.quantity) || 0;

        if (existing) {
          const existingQty = parseInt(existing.quantity) || 0;
          const totalQty = existingQty + currentQty;

          // Check quantity threshold
          if (totalQty < 500) {
            existing.quantity = totalQty.toString();
            existing.item_name = [existing.item_name, task.item_name]
              .filter(Boolean)
              .join(", ");
            return;
          }
        }

        // Create new entry if not merging
        const clonedTask = { ...task };
        mergeMap.set(key, clonedTask);
        mergedTasks.push(clonedTask);
      } else if (task && task?.position && typeof task.position === "number") {
        // Handle case when position is a number
        const key = `${task.type}_${task.position}`;
        const existing = mergeMap.get(key);
        const currentQty = parseInt(task?.quantity) || 0;

        if (existing) {
          const existingQty = parseInt(existing.quantity) || 0;
          const totalQty = existingQty + currentQty;

          // Check quantity threshold
          if (totalQty < 500) {
            existing.quantity = totalQty.toString();
            existing.item_name = [existing.item_name, task.item_name]
              .filter(Boolean)
              .join(", ");
            return;
          }
        }

        // Create new entry if not merging
        const clonedTask = { ...task };
        mergeMap.set(key, clonedTask);
        mergedTasks.push(clonedTask);
      } else {
        // Add tasks with empty position without merging
        mergedTasks.push(task);
      }
    } else {
      mergedTasks.push(task);
    }
  });

  modifiedTasks = mergedTasks;

  // 3. Add pour tasks where needed (after open lid) - skip if parent task exists in array
  modifiedTasks.forEach((task, index) => {
    const pourType = POUR_TASK_MAP[task?.type];
    if (pourType) {
      // Check if this is the task that was removed for dispenser checking
      // If so, we should still add the pour task since the dispenser check handles the dispensing
      const shouldAddPourTask = true; // Always add pour task if the parent choose task exists

      if (shouldAddPourTask) {
        const previousOpenLidIndex = modifiedTasks
          .slice(0, index)
          .reverse()
          .findIndex((t) => t?.type === "open_lid");
        const nextCloseLidIndex = modifiedTasks
          .slice(index)
          .findIndex((t) => t?.type === "close_lid");

        const hasPourTask = modifiedTasks
          .slice(
            index + 1,
            nextCloseLidIndex > -1 ? index + nextCloseLidIndex : undefined
          )
          .some((t) => t?.type === pourType);

        if (!hasPourTask) {
          const pourTask = {
            ...staticTasks.find((t) => t?.type === pourType),
            id: generateId(),
          };

          if (previousOpenLidIndex === -1) {
            const openLidTask = {
              ...staticTasks.find((t) => t?.type === "open_lid"),
              id: generateId(),
            };
            modifiedTasks.splice(index, 0, openLidTask);
            modifiedTasks.splice(index + 1, 0, pourTask);
          } else {
            modifiedTasks.splice(index + 1, 0, pourTask);
          }
        }
      }
    }
  });

  // 4. Remove orphan pour tasks - skip validation if parent type doesn't exist anywhere
  modifiedTasks = modifiedTasks.filter((task, index) => {
    if (REVERSE_POUR_MAP[task?.type]) {
      const parentType = REVERSE_POUR_MAP[task?.type];

      // Check if parent type exists anywhere in the tasks (not just before this task)
      const hasAnyParentInTasks = modifiedTasks.some(
        (t) => t?.type === parentType
      );

      // If no parent exists anywhere, keep the pour task (parent was likely removed by dispenser check)
      if (!hasAnyParentInTasks) {
        console.log(
          `⚠️ No ${parentType} found in tasks, keeping ${task?.type} (parent likely removed by dispenser check)`
        );
        return true;
      }

      // Original logic for when parent exists
      const hasParent = modifiedTasks
        .slice(0, index)
        .some((t) => t?.type === parentType);
      const hasOpenLidBefore = modifiedTasks
        .slice(0, index)
        .some((t) => t?.type === "open_lid");
      return hasParent && hasOpenLidBefore;
    }
    return true;
  });

  // 5. Validate heat on/off pairs
  let heatOnIndex = -1;
  modifiedTasks.forEach((task, index) => {
    if (task?.function === "setHeat" && task?.level === "on") {
      heatOnIndex = index;
    }
    if (
      task?.function === "setHeat" &&
      task?.level === "off" &&
      heatOnIndex !== -1
    ) {
      heatOnIndex = -1;
    }
  });

  if (heatOnIndex !== -1) {
    const chimneyOffIndex = findTaskIndex("chimney_off");
    const heatOffTask = {
      ...staticTasks.find(
        (t) => t?.function === "setHeat" && t?.level === "off"
      ),
      id: generateId(),
    };
    modifiedTasks.splice(chimneyOffIndex, 0, heatOffTask);
  }

  // Remove duplicates and invalid tasks
  const seenIds = new Set();
  return modifiedTasks.filter((task) => {
    if (!task?.id || seenIds.has(task.id)) return false;
    seenIds.add(task.id);
    return true;
  });
};

// // utils/taskValidations.js
// import { cookingTasks as staticTasks } from "../Static/task";

// const POUR_TASK_MAP = {
//   choose_grains: "pour_grain",
//   choose_spices: "pour_spice",
//   choose_soaks: "pour_soaks",
// };

// const REVERSE_POUR_MAP = {
//   pour_grain: "choose_grains",
//   pour_spice: "choose_spices",
//   pour_soaks: "choose_soaks",
// };

// export const cookingTasksValidation = (tasks) => {
//   // console.log("before", tasks);
//   let modifiedTasks = [...tasks];
//   console.log("modifiedTask", modifiedTasks);

//   // Helper functions
//   const hasTaskType = (type) => modifiedTasks.some((t) => t?.type === type);
//   const findTaskIndex = (type, start = 0) =>
//     modifiedTasks.findIndex((t, i) => i >= start && t?.type === type);
//   const generateId = () =>
//     `task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

//   // 1. Chimney On/Off validation with IDs
//   if (!hasTaskType("chimney_on")) {
//     const chimneyOnTask = {
//       ...staticTasks.find((t) => t?.type === "chimney_on"),
//       id: generateId(),
//     };
//     modifiedTasks.unshift(chimneyOnTask);
//   }
//   if (!hasTaskType("chimney_off")) {
//     const chimneyOffTask = {
//       ...staticTasks.find((t) => t?.type === "chimney_off"),
//       id: generateId(),
//     };
//     modifiedTasks.push(chimneyOffTask);
//   }

//   // 2. Merge manual bowl/cup tasks
//   const manualTasks = modifiedTasks.filter((t) =>
//     ["choose_bowl", "choose_cup"].includes(t?.type)
//   );

//   const positionMap = new Map();
//   manualTasks.forEach((task) => {
//     const key = `${task.type}_${task.position}`;
//     if (positionMap?.has(key)) {
//       const existing = positionMap.get(key);
//       existing.types.add(task.type);
//     } else {
//       positionMap.set(key, {
//         types: new Set([task.type]),
//         firstIndex: modifiedTasks.findIndex((t) => t?.id === task.id),
//       });
//     }
//   });

//   positionMap.forEach((value, key) => {
//     if (value.types.size > 1) {
//       const mergedTask = {
//         ...staticTasks.find((t) => t?.type === "merged_container"),
//         position: modifiedTasks[value.firstIndex].position,
//         name: `Merged Container ${modifiedTasks[value.firstIndex].position}`,
//         id: generateId(),
//       };
//       modifiedTasks = modifiedTasks.map((t) =>
//         t?.position === mergedTask?.position &&
//         ["choose_bowl", "choose_cup"].includes(t?.type)
//           ? mergedTask
//           : t
//       );
//     }
//   });

//   // 3. Add pour tasks where needed (after open lid)
//   modifiedTasks.forEach((task, index) => {
//     const pourType = POUR_TASK_MAP[task?.type];
//     if (pourType) {
//       // Find the nearest preceding open lid task
//       const previousOpenLidIndex = modifiedTasks
//         .slice(0, index)
//         .reverse()
//         .findIndex((t) => t?.type === "open_lid");

//       // Find the next close lid task
//       const nextCloseLidIndex = modifiedTasks
//         .slice(index)
//         .findIndex((t) => t?.type === "close_lid");

//       const hasPourTask = modifiedTasks
//         .slice(
//           index + 1,
//           nextCloseLidIndex > -1 ? index + nextCloseLidIndex : undefined
//         )
//         .some((t) => t?.type === pourType);

//       if (!hasPourTask) {
//         const pourTask = {
//           ...staticTasks.find((t) => t?.type === pourType),
//           id: generateId(),
//         };

//         // If no open lid found before, add one
//         if (previousOpenLidIndex === -1) {
//           const openLidTask = {
//             ...staticTasks.find((t) => t?.type === "open_lid"),
//             id: generateId(),
//           };
//           modifiedTasks.splice(index, 0, openLidTask);
//           modifiedTasks.splice(index + 1, 0, pourTask);
//         } else {
//           modifiedTasks.splice(index + 1, 0, pourTask);
//         }
//       }
//     }
//   });

//   // 4. Remove orphan pour tasks
//   modifiedTasks = modifiedTasks.filter((task, index) => {
//     if (REVERSE_POUR_MAP[task?.type]) {
//       const parentType = REVERSE_POUR_MAP[task?.type];
//       const hasParent = modifiedTasks
//         .slice(0, index)
//         .some((t) => t?.type === parentType);
//       const hasOpenLidBefore = modifiedTasks
//         .slice(0, index)
//         .some((t) => t?.type === "open_lid");
//       return hasParent && hasOpenLidBefore;
//     }
//     return true;
//   });

//   // 5. Heat On/Off validation with IDs
//   let heatOnIndex = -1;
//   modifiedTasks.forEach((task, index) => {
//     if (task?.function === "setHeat" && task?.level === "on") {
//       heatOnIndex = index;
//     }
//     if (
//       task?.function === "setHeat" &&
//       task?.level === "off" &&
//       heatOnIndex !== -1
//     ) {
//       heatOnIndex = -1;
//     }
//   });

//   if (heatOnIndex !== -1) {
//     const chimneyOffIndex = findTaskIndex("chimney_off");
//     const heatOffTask = {
//       ...staticTasks.find(
//         (t) => t?.function === "setHeat" && t?.level === "off"
//       ),
//       id: generateId(),
//     };
//     modifiedTasks.splice(chimneyOffIndex, 0, heatOffTask);
//   }

//   // Remove duplicates and invalid tasks
//   const seenIds = new Set();
//   return modifiedTasks.filter((task) => {
//     if (!task?.id || seenIds.has(task.id)) return false;
//     seenIds.add(task.id);
//     return true;
//   });
// };
